<template>
  <a-card size="small">
    <a-input-search v-model="searchValue" class="application-search" placeholder="搜索您的应用" @search="getApplicationList" />
    <a-skeleton v-if="loading" />
    <div v-else>
      <template v-if="applicationData.length > 0">
        <div v-for="(application, index) in applicationData" :key="index">
          <div :class="`${application.app_key === current ? 'application-item application-item_active' : 'application-item'}`" @click="onApplication(application.app_key)">
            <a-avatar class="application-item_logo" shape="square" size="large" :src="application.logo" />
            <div class="application-item_info">
              <span class="application-item_name">{{ application.name }}</span>
              <span class="application-item_platform">{{ application.platform }}</span>
            </div>
          </div>
        </div>
      </template>
      <a-empty v-else />
    </div>
  </a-card>
</template>

<script>
import { applicationList } from '@/api/tools/application';

export default {
  data() {
    return {
      loading: true,
      searchValue: null,
      applicationData: [],
      applicationTotal: 0,
      current: this.$route.query.appKey || null,
      appKey: null
    };
  },
  watch: {
    current() {
      this.$emit('selected', this.current);
    }
  },
  created() {
    this.getApplicationList();
  },
  methods: {
    getApplicationList() {
      this.loading = true;
      applicationList({ name: this.searchValue })
        .then(res => {
          this.applicationData = res.data.items;
          this.total = res.data.total;
          if (this.current === null) {
            this.current = this.applicationData[0].app_key;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    onApplication(app_key) {
      this.current = app_key;
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.ant-card-body {
  padding: 12px 12;
  height: calc(~'100vh - 140px');
}

.application-search {
  margin-bottom: 8px;
}

.application-item {
  height: 60px;
  line-height: 40px;
  cursor: pointer;
  padding: 8px;
  margin: 8px -12px;
  border-left: 4px solid #ffffff;
  .application-item_logo {
    float: left;
  }
  .application-item_info {
    float: left;
    margin-left: 8px;
    .application-item_name {
      display: block;
      font-size: 16px;
      color: #5a5959;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      line-height: 24px;
    }
    .application-item_platform {
      display: block;
      margin-top: 2px;
      line-height: 14px;
      font-size: 13px;
      color: #9e9e9e;
      position: relative;
    }
  }
}

.application-item:hover,
.application-item_active {
  background-color: #e6f7ff;
  color: #1890ff;
  border-left: 4px solid #1890ff;
}

.application-item_more {
  float: right;
  font-weight: bold;
}
</style>
